// extracted by mini-css-extract-plugin
export default {"productGallery":"iK-z","inQuickShop":"jK-z"};